import template from './contract.html';
import controller from './contract.controller';
import './contract.scss';

let contractComponent = {
  restrict: 'E',
  bindings: {
  	acl: '=',
    hasACL:'='
  },
  template,
  controller
};

export default contractComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract/contract.component.js